import { render, staticRenderFns } from "./BookingRepx.vue?vue&type=template&id=5152a362"
import script from "./BookingRepx.vue?vue&type=script&lang=js"
export * from "./BookingRepx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports